module.exports = __webpack_public_path__ + "static/artillery-logo-dark-112b42b32764a973c461edde87fdaeaf.png";